import { IAppState } from '@state/types';

export const getUserFiles = (state: IAppState): any | undefined => state.userFiles.userFiles;

export const getUserFilesResponse = (state: IAppState): any | undefined => state.userFiles.response;

export const getUserFilesSearchUserFiles = (state: IAppState): any | undefined => state.userFiles.searchesUserFiles;

export const getUserFilesCounter = (state: IAppState): any | undefined => state.userFiles.counter;